import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=d7e40db6&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=d7e40db6&prod&lang=scss&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=d7e40db6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e40db6",
  null
  
)

export default component.exports